import axiosService from "../axios";

export interface IContactForm {
    type: "bug" | "addition" | "support" | "message" | null;
    subject: "";
    message: "";
}
export interface IContactToast {
    open: boolean;
    message: string;
    severity: "success" | "error";
}

export const handleContactFormChange =
    (key: keyof IContactForm, setForm: React.Dispatch<React.SetStateAction<IContactForm>>) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setForm((f) => ({ ...f, [key]: e.target.value }));
    };

const validate = (form: IContactForm, setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>) => {
    const next: Record<string, string> = {};

    if (!form.subject.trim()) next.subject = "Please add a subject";
    if (!form.message.trim()) next.message = "Please write a message";

    setErrors(next);
    return Object.keys(next).length === 0;
};

export const handleContactFormSubmit = async (
    e: React.FormEvent,
    form: IContactForm,
    setToast: React.Dispatch<React.SetStateAction<IContactToast>>,
    setForm: React.Dispatch<React.SetStateAction<IContactForm>>,
    setSubmitting: React.Dispatch<React.SetStateAction<boolean>>,
    setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>
) => {
    e.preventDefault();
    if (!validate(form, setErrors)) return;

    setSubmitting(true);
    try {
        // Prefer your existing axiosService if available. Fallback to fetch.
        const payload = { ...form, source: "contact_page" };
        axiosService.post(`${process.env.REACT_APP_API_URL}/contact/send`, payload).then((res) => {
            if (res.status !== 200) setErrors({ send: "Error while sending message. Please try again later." });

            setToast({ open: true, message: "Thanks! Your message has been sent.", severity: "success" });
            setForm({ ...form, subject: "", message: "" });
            setErrors({});
        });
    } catch (err) {
        setToast({ open: true, message: "Something went wrong. Please try again.", severity: "error" });
    } finally {
        setSubmitting(false);
    }
};
